module.exports = __webpack_public_path__ + "img/DODlabs.1d582166.svg";